/**
 * Created by Fayaz on 2/13/2018.
 */
import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';

import {RestangularModule, Restangular} from 'ngx-restangular';
import { tap } from 'rxjs/operators';
const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};

@Injectable()
export class MenuService {
  private readonly CACHE_KEY_PREFIX = 'menu_cache_';
  private readonly CACHE_DURATION = 24 * 60 * 60 * 1000; 
  constructor(private restangular: Restangular) {
  }

  getCompanies() {
    return this.restangular.one('user/companies');
  }

  getMenuByCompany() {
    return this.restangular.one('user/menu');
  }

  getApprovalCounts() {
    return this.restangular.one('getApprovalCounts');
  }

  getCorrectiveActionCounts() {
    return this.restangular.one('getCorrectiveActionCounts');
  }

  getDmsApprovalCount() {
    return this.restangular.one('get_dms_approvals_count');
  }

  getMyAssessmentsCounts() {
    return this.restangular.one('getMyAssessmentsCounts');
  }
  
  getMyAssCorrectionCounts() {
    return this.restangular.one('getMyAssCorrectionCounts');
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/menu.service.ts